<template>
  <div class="main main--customers">
    <div class="main__title main__title--3row">
      <div @click="fjfj()">返回</div>
      <h2>補課課程</h2>
      <div class="icon">
      </div>
    </div>
    <div class="courseContent">
      <div class="courseContent__image">
              <img :src="hha.courseProfileUrl" alt="Smiley face" width="100%">
      </div>
      <div class="courseContent__title">
        <h3>{{ hha.courseName }}</h3>
      </div>
      <div class="courseContent__unit">
        <h3>課程</h3>
        <div class="unit-list">
          <div v-for="(unit, index) in hha.courseSection" :key="index" class="unit-list__item">
            <div class="number">
              {{ unit.sectionOrder }}
            </div>
            <div class="title">
              <div>{{ unit.sectionName }}</div>
            </div>
            <div class="button">
              <button class="start" @click="toVideo(unit.id)">開始</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('@/firebaseConfig.js')

export default {
  computed: {
    ...mapState(['onlineCourse'])
  },
  created () {
    const courseId = this.$route.path.split('/').pop()
    let result = {}
    this.onlineCourse.forEach(course => {
      if (course.courseId === courseId) {
        result = course
      }
    })
    this.hha = result

    fb.db.collection('onlinecourse').doc(courseId).collection('courseSection').get().then(querySnapshot => {
      let customersArray = []
      querySnapshot.forEach(doc => {
        let customer = doc.data()
        customer.id = doc.id
        customersArray.unshift(customer)
      })
      this.sections = customersArray
    })
  },
  data () {
    return {
      reviewCourses: [
        {}, {}
      ],
      hha: null,
      sections: []
    }
  },
  methods: {
    fjfj () {
      let thisName = this.$route.path.split('/')
      thisName.pop()
      const result = thisName.join('/')
      this.$router.push({ path: result })
    },
    toVideo (p) {
      this.$router.push({ path: this.$route.path + '/' + p })
    }
  }
}
</script>

<style lang="scss" scoped>
button.start {
  width: 100%;
  background: #f9f9f9;
  border: 1px solid #e9e9e9;
  padding: .5rem;
  line-height: 2em;
  border-radius: 6px;
  font-size: 1em;
  font-weight: 700;
  &:hover {
    background: #333;
    color: #FFF;
  }
}
.courseContent {
  font-size: 18px;
  .courseContent__image {
    width: 100%;
    height: 240px;
    background: pink;
    overflow: hidden;
  }
  .courseContent__title {
    padding: 2rem;
    h3 {
      font-size: 1.5em;
      margin-bottom: 1rem;
    }
  }
  .courseContent__intro {
    background: #f9f9f9;
    padding: 2rem;
    h3 {
      margin-bottom: 1rem;
    }
  }
  .courseContent__unit {
    padding: 2rem;
    h3 {
      margin-bottom: 1rem;
    }
    .unit-list__item {
      line-height: 3em;
      display: grid;
      grid-template-columns: 1fr 7fr 2fr;
      font-weight: 700;
        .grey {
          color: #333;
        }
      }
    }
}
</style>
